enum ButtonTheme {
  Navy = "Navy",
}

export default ButtonTheme;
